export default {
  rate: 0,
  good: "",
  bad: "",
  comment: "",
  recommend: false,
  goodOrBad: [
    { name: "Удобство платформы", value: 0 },
    { name: "Скорость рассмотрения", value: 0 },
    { name: "% одобрений", value: 0 },
    { name: "Согласование правок", value: 0 },
    { name: "Поддерждка куратора", value: 0 },
    { name: "Тарифная сетка", value: 0 },
    { name: "Скидка без снижения КВ", value: 0 },
    { name: "Отправка оригиналов БГ", value: 0 },
    { name: "Подготовка актов", value: 0 },
    { name: "Скорость выплат КВ", value: 0 },
  ],
  allProduct: [],
}
